import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ScrollReveal from "@/components/ScrollReveal";
import { ArrowLeft, PartyPopper, Palette, Star, MapPin, Phone, Navigation } from "lucide-react";

const WHATSAPP_URL = "https://wa.me/556193761185?text=Ol%C3%A1!%20Vim%20pelo%20site%20e%20gostaria%20de%20um%20or%C3%A7amento.";
const BLUE_PHOTO = "https://customer-assets.emergentagent.com/job_celebration-hub-359/artifacts/e08sr901_ChatGPT%20Image%2026%20de%20mai.%20de%202026%2C%2013_04_35.png";
const MAPS_LINK = "https://share.google/uZeGpdMSnkFJ2Nav3";

const SERVICES_LIST = [
  {
    title: "Decoração de Festas Infantis em Brasília",
    text: "A Amine Festas é especialista em decoração de festas infantis em Brasília e região. Criamos cenários mágicos e personalizados que transformam o sonho do seu filho em realidade. Desde temas clássicos até os mais criativos, cada detalhe é pensado para encantar crianças e adultos. Trabalhamos com balões, flores, tecidos, estruturas e iluminação para criar ambientes únicos e memoráveis.",
  },
  {
    title: "Chá de Bebê e Chá Revelação em Brasília",
    text: "Momentos especiais merecem uma decoração à altura. Nossos chás de bebê e chás revelação são planejados com muito carinho, desde a paleta de cores até os últimos detalhes. Criamos cenários que se tornam o palco perfeito para a revelação do sexo do bebê, com setups fotográficos incríveis, arcos de balões e mesas decoradas que encantam todos os convidados.",
  },
  {
    title: "Decoração para Eventos Corporativos",
    text: "Além de festas pessoais, a Amine Festas atende eventos corporativos em Brasília. Confraternizações, lançamentos de produtos, eventos de final de ano e muito mais. Adaptamos a decoração ao branding da sua empresa, criando ambientes elegantes e profissionais que impressionam colaboradores e clientes.",
  },
  {
    title: "Designer de Balões Personalizados",
    text: "Somos especialistas em designer de balões em Brasília. Criamos arcos orgânicos, bouquets, colunas, centros de mesa e instalações artísticas com balões. Cada composição é feita sob medida, combinando cores, tamanhos e texturas para criar visual impactante e harmonioso para qualquer tipo de celebração.",
  },
  {
    title: "Festas Temáticas Personalizadas",
    text: "Na Amine Festas, cada festa é única. Desenvolvemos decorações temáticas totalmente personalizadas, desde o conceito criativo até a montagem final. Trabalhamos com os temas mais populares e também criamos temas exclusivos baseados nos seus desejos. Galinha Pintadinha, Safari, Princesas, Super-Heróis, Unicórnio e muito mais.",
  },
];

const SEO_KEYWORDS = [
  "decoração de festas brasília",
  "balões personalizados brasília",
  "chá revelação brasília",
  "festa infantil temática brasília",
  "decoração eventos corporativos df",
  "designer de balões brasília",
  "amine festas brasília",
  "decoração personalizada festas",
];

const BLOG_ARTICLES = [
  {
    title: "Como Escolher o Tema Perfeito para a Festa do Seu Filho em Brasília",
    paragraphs: [
      "Escolher o tema da festa infantil é uma das decisões mais importantes — e também mais divertidas — de todo o processo. Em Brasília, o mercado de festas infantis movimenta milhões por ano, com famílias investindo cada vez mais em decorações personalizadas e experiências memoráveis para seus filhos.",
      "Na Amine Festas, orientamos os pais desde a escolha do tema até a paleta de cores. Os temas mais procurados em Brasília incluem Safari, Princesas Disney, Super-Heróis Marvel e DC, Astronauta, Minnie e Mickey, Galinha Pintadinha, Bluey, Patrulha Canina e Moana. Mas nosso diferencial são os temas exclusivos e personalizados como Jardim Encantado, Nárnia, Chapeuzinho Vermelho, Fundo do Mar e Circo Vintage.",
      "O mercado de decoração de festas infantis no Brasil cresce cerca de 14% ao ano. Em Brasília, esse crescimento é ainda maior por conta do alto poder aquisitivo da população e da cultura local de valorizar celebrações familiares. Uma festa infantil decorada profissionalmente em Brasília custa entre R$ 1.500 e R$ 8.000, dependendo da complexidade do tema e dos materiais utilizados.",
      "Uma dica valiosa: considere o local da festa ao escolher o tema. Decorações em áreas externas — muito populares em condomínios de Águas Claras, Vicente Pires e Jardim Botânico — pedem materiais resistentes ao vento e à umidade. Já festas em salões e buffets permitem estruturas mais elaboradas com painéis de 3 metros, arcos duplos de balões e iluminação cenográfica.",
    ],
    list: [
      "Pergunte ao seu filho qual o personagem ou cor favorita — a festa é dele",
      "Defina a paleta de cores (máximo 3 cores) antes de comprar qualquer item",
      "Considere a faixa etária dos convidados ao escolher a temática",
      "Invista em personalização: convites, lembrancinhas, bolo e decoração no mesmo tema",
      "Contrate profissionais com portfólio comprovado e avaliações reais de clientes",
      "Reserve o decorador com pelo menos 30 dias de antecedência em alta temporada",
    ],
  },
  {
    title: "Chá Revelação em Brasília: Tendências e Ideias para 2027",
    paragraphs: [
      "O chá revelação se consolidou como um dos eventos mais emocionantes da gestação em Brasília. A cada ano, as decorações ficam mais sofisticadas e personalizadas, e 2027 traz novidades que unem elegância, criatividade e muita emoção para o grande momento da descoberta.",
      "As tendências de chá revelação em Brasília para 2027 incluem paletas neutras com toques de rosa e azul, temas celestiais com luas, estrelas e nuvens, decorações com arcos de balões orgânicos em tons pastel e mesa de doces minimalista com peças em acrílico. Outro destaque são os blocos BABY personalizados, cilindros com flores preservadas e backdrops com tecido drapeado.",
      "Na Amine Festas, cada chá revelação é tratado como único. Trabalhamos com materiais premium como balões chrome, flores naturais e artificiais de alta qualidade, estruturas metálicas douradas e iluminação LED. O resultado são cenários dignos de capa de revista, que geram fotos inesquecíveis e fazem o momento da revelação ser ainda mais especial.",
      "Em Brasília, os espaços mais procurados para chá revelação incluem salões de festas no Lago Sul e Lago Norte, áreas externas em Vicente Pires e Águas Claras, e buffets no Sudoeste e Noroeste. Cada espaço pede uma abordagem diferente de decoração, e nossa equipe adapta o projeto ao ambiente para maximizar o impacto visual.",
    ],
  },
  {
    title: "Decoração de Aniversário Adulto: Elegância e Personalidade em Brasília",
    paragraphs: [
      "Aniversários adultos representam um segmento em forte crescimento no mercado de decoração de Brasília. Cada vez mais homens e mulheres de 18 a 80+ anos buscam celebrar marcos importantes com decorações que reflitam sua personalidade, estilo e história de vida.",
      "Para homens, as tendências em Brasília incluem temas em preto e prata com neon, azul marinho com dourado, boteco com cervejas artesanais, churrasco gourmet e decorações rústicas com madeira de demolição. Para mulheres, rosa millennial com dourado, tons terrosos com chocolate, flores naturais em tons nude, garden party e festas temáticas como anos 70, 80 e 90 fazem sucesso.",
      "A Amine Festas se destaca na decoração de aniversários adultos em Brasília por oferecer consultoria completa de estilo. Analisamos o espaço do evento, a quantidade de convidados (de jantares íntimos com 20 pessoas a festas com 200+), o estilo pessoal do aniversariante e o orçamento disponível para criar propostas sob medida.",
      "Os bairros mais procurados para festas adultas em Brasília são Lago Sul, Lago Norte, Asa Norte, Asa Sul, Sudoeste e Park Sul, além de espaços de eventos em Águas Claras e Vicente Pires. Cada local demanda uma logística específica de montagem e desmontagem que nossa equipe domina com mais de 2.000 eventos realizados.",
    ],
    list: [
      "Defina o estilo: clássico, moderno, rústico, industrial ou temático",
      "Escolha até 3 cores para a paleta principal — menos é mais",
      "Neon e letreiros luminosos personalizados adicionam personalidade",
      "Arranjos de balões metálicos chrome criam impacto visual sofisticado",
      "Considere a iluminação como parte fundamental da decoração",
      "Flores naturais elevam qualquer decoração adulta — rosas, orquídeas e peônias são atemporais",
    ],
  },
  {
    title: "Por Que Contratar um Decorador Profissional Faz Toda a Diferença",
    paragraphs: [
      "Segundo a ABRAFESTA (Associação Brasileira de Eventos Sociais), mais de 70% dos anfitriões que optam por decoração profissional relatam satisfação total com o resultado, enquanto apenas 30% dos que fazem por conta própria ficam plenamente satisfeitos. A diferença está nos detalhes, na experiência e no acesso a materiais de qualidade superior.",
      "Um decorador profissional em Brasília cuida de todo o processo: briefing inicial, projeto visual, orçamento detalhado, compra de insumos, montagem no dia (geralmente 3 a 5 horas antes do evento) e desmontagem completa após a festa. Isso significa que o anfitrião pode aproveitar 100% do evento sem estresse.",
      "Na Amine Festas, o atendimento começa pelo WhatsApp — sem formulários frios ou robôs. A Amine conversa pessoalmente com cada cliente para entender o sonho, as referências visuais, o orçamento e os prazos. O projeto visual é enviado para aprovação antes da execução, garantindo transparência total.",
      "O investimento em decoração profissional se paga em experiência: fotos que duram para sempre, a reação dos convidados ao chegarem, o orgulho do aniversariante e a tranquilidade de saber que tudo foi pensado nos mínimos detalhes. Com mais de 2.000 festas no portfólio, a Amine Festas é referência em decoração personalizada no Distrito Federal.",
    ],
  },
  {
    title: "Tendências de Balões Personalizados para Festas em Brasília em 2027",
    paragraphs: [
      "O mercado de balloon art no Brasil é um dos que mais cresce no segmento de eventos. Em Brasília, a demanda por designer de balões profissional aumentou 40% nos últimos dois anos, impulsionada pelas redes sociais e pela busca por decorações instagramáveis.",
      "Arcos orgânicos continuam como tendência número um em 2027: composições assimétricas que combinam balões de diferentes tamanhos (5 a 36 polegadas), texturas (matte, chrome, confete, duplo stuffing) e cores. A novidade são os arcos com flores naturais integradas, que unem a delicadeza das pétalas com o impacto visual dos balões.",
      "Outras tendências fortes incluem colunas helicoidais, centros de mesa com balões de 11 polegadas, bouquets de chão para delimitar espaços, topo de bolo com mini-balões e instalações suspensas para tetos altos — muito populares em salões do Lago Sul e Sudoeste.",
      "A Amine Festas trabalha exclusivamente com balões Sempertex e Qualatex, referências mundiais em qualidade e durabilidade. Cada composição é calculada com precisão para garantir que os balões mantenham a forma durante toda a festa, mesmo em ambientes externos com calor e vento, comuns em Brasília.",
    ],
    list: [
      "Arcos orgânicos com mix de tamanhos, texturas e flores naturais",
      "Balões chrome (metálicos) em ouro, prata e rose gold para sofisticação",
      "Bouquets de chão com base em água para estabilidade ao ar livre",
      "Balões com confete metalizado para mesas e centros de mesa",
      "Instalações suspensas e cascatas de balões para tetos acima de 3 metros",
      "Balões personalizados com nome, idade e adesivos temáticos",
    ],
  },
];

export default function SeoPage() {
  return (
    <div data-testid="seo-page" className="min-h-screen bg-[#f9f9f9]">
      <Header />

      {/* Hero Banner */}
      <section className="pt-32 pb-16 bg-[#1a1a1a] relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-[#E4077B]/10 via-transparent to-[#00929A]/10" />
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12">
          <Link
            to="/"
            data-testid="seo-back-link"
            className="inline-flex items-center gap-2 text-white/60 hover:text-white text-sm mb-8 transition-colors"
          >
            <ArrowLeft size={16} />
            Voltar para Home
          </Link>
          <h1
            className="text-4xl sm:text-5xl lg:text-6xl font-light text-white tracking-tight leading-tight"
            style={{ fontFamily: "Outfit, sans-serif" }}
          >
            Decoração de Festas
            <span className="block text-[#E4DCCC]">Personalizadas em Brasília</span>
          </h1>
          <p className="text-white/70 text-base md:text-lg max-w-2xl mt-6 font-light">
            Amine Festas: a melhor opção para decoração de festas infantis, chás de bebê, chás revelação e eventos corporativos em Brasília-DF.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          {/* Introduction */}
          <div className="max-w-4xl mx-auto mb-20">
            <h2
              className="text-3xl sm:text-4xl font-light text-[#1a1a1a] tracking-tight mb-6"
              style={{ fontFamily: "Outfit, sans-serif" }}
            >
              Por que escolher a Amine Festas?
            </h2>
            <p className="text-[#555555] leading-relaxed text-base mb-4">
              Com mais de 2.000 festas realizadas em Brasília e região, a Amine Festas se consolidou como referência em decoração de festas personalizadas no Distrito Federal. Nossa fundadora, Amine Cudo, traz a sensibilidade de quem ama o que faz e a experiência de anos transformando celebrações em memórias inesquecíveis.
            </p>
            <p className="text-[#555555] leading-relaxed text-base">
              Somos mais do que decoradores: somos criadores de experiências. Cada balão, flor, tecido e estrutura é pensado para valorizar a história de quem está comemorando e oferecer uma experiência completa, pronta e inesquecível.
            </p>
          </div>

          {/* Services Grid */}
          <div className="space-y-16">
            {SERVICES_LIST.map((service, i) => (
              <article
                key={i}
                className="grid lg:grid-cols-12 gap-8 items-start"
                data-testid={`seo-service-${i}`}
              >
                <div className="lg:col-span-1 flex items-center">
                  <div className="w-12 h-12 rounded-2xl bg-[#E4077B]/10 flex items-center justify-center">
                    {i === 0 && <PartyPopper size={20} className="text-[#E4077B]" />}
                    {i === 1 && <Star size={20} className="text-[#E4077B]" />}
                    {i === 2 && <Palette size={20} className="text-[#E4077B]" />}
                    {i === 3 && <PartyPopper size={20} className="text-[#00929A]" />}
                    {i === 4 && <Star size={20} className="text-[#f39200]" />}
                  </div>
                </div>
                <div className="lg:col-span-11">
                  <h3
                    className="text-2xl font-light text-[#1a1a1a] tracking-tight mb-4"
                    style={{ fontFamily: "Outfit, sans-serif" }}
                  >
                    {service.title}
                  </h3>
                  <p className="text-[#555555] leading-relaxed text-base">{service.text}</p>
                </div>
              </article>
            ))}
          </div>

          {/* Blue Photo Feature */}
          <ScrollReveal>
            <div className="mt-20 overflow-hidden rounded-3xl">
              <img
                src={BLUE_PHOTO}
                alt="Festa temática azul com decoração de astronauta"
                className="w-full h-64 md:h-96 object-cover"
                data-testid="seo-blue-photo"
              />
            </div>
          </ScrollReveal>

          {/* Location & Contact */}
          <ScrollReveal>
            <div className="mt-16 grid md:grid-cols-3 gap-8">
              <div className="bg-white rounded-3xl p-8">
                <div className="flex items-center gap-3 mb-4">
                  <MapPin size={20} className="text-[#E4077B]" />
                  <h3 className="text-lg font-light text-[#1a1a1a]" style={{ fontFamily: "Outfit, sans-serif" }}>
                    Área de Atendimento
                  </h3>
                </div>
                <p className="text-[#555555] text-sm leading-relaxed">
                  Atendemos toda Brasília e região do Distrito Federal, incluindo Plano Piloto, Lago Sul, Lago Norte, Águas Claras, Taguatinga, Guará, Sudoeste, Noroeste, Vicente Pires, Samambaia e regiões adjacentes.
                </p>
              </div>
              <div className="bg-white rounded-3xl p-8">
                <div className="flex items-center gap-3 mb-4">
                  <Navigation size={20} className="text-[#00929A]" />
                  <h3 className="text-lg font-light text-[#1a1a1a]" style={{ fontFamily: "Outfit, sans-serif" }}>
                    Loja Física
                  </h3>
                </div>
                <p className="text-[#555555] text-sm leading-relaxed mb-4">
                  Venha nos visitar! Conheça nosso espaço e veja de perto a qualidade dos nossos materiais e decorações.
                </p>
                <a
                  href={MAPS_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="seo-maps-link"
                  className="inline-flex items-center gap-2 text-[#00929A] hover:text-[#007a80] text-sm font-medium transition-colors"
                >
                  <MapPin size={16} />
                  Ver no Google Maps
                </a>
              </div>
              <div className="bg-white rounded-3xl p-8">
                <div className="flex items-center gap-3 mb-4">
                  <Phone size={20} className="text-[#f39200]" />
                  <h3 className="text-lg font-light text-[#1a1a1a]" style={{ fontFamily: "Outfit, sans-serif" }}>
                    Fale Conosco
                  </h3>
                </div>
                <p className="text-[#555555] text-sm leading-relaxed mb-4">
                  Solicite seu orçamento personalizado diretamente pelo WhatsApp. Atendimento rápido, humano e sem formulários frios.
                </p>
                <a
                  href={WHATSAPP_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="seo-whatsapp-btn"
                  className="inline-flex items-center justify-center bg-[#E4077B] hover:bg-[#c8066a] text-white px-6 py-3 rounded-full text-sm font-medium transition-all duration-300"
                >
                  Falar com Amine Festas
                </a>
              </div>
            </div>
          </ScrollReveal>

          {/* Keywords/Tags */}
          <div className="mt-16 text-center">
            <p className="text-xs text-[#555555]/60 uppercase tracking-wider mb-4">Tags</p>
            <div className="flex flex-wrap justify-center gap-2">
              {SEO_KEYWORDS.map((kw, i) => (
                <span
                  key={i}
                  className="text-xs text-[#555555] bg-[#E4DCCC]/40 px-4 py-2 rounded-full"
                >
                  {kw}
                </span>
              ))}
            </div>
          </div>

          {/* Blog Articles */}
          <ScrollReveal>
            <div className="mt-24">
              <div className="text-center mb-16">
                <span className="text-[#00929A] text-xs tracking-[0.25em] uppercase font-medium">Blog</span>
                <h2 className="text-3xl sm:text-4xl font-light text-[#1a1a1a] tracking-tight mt-3" style={{ fontFamily: "Outfit, sans-serif" }}>
                  Dicas e Inspirações
                </h2>
                <div className="w-12 h-0.5 bg-[#00929A] mx-auto mt-4" />
              </div>

              <div className="space-y-20 max-w-4xl mx-auto">
                {BLOG_ARTICLES.map((article, i) => (
                  <article key={i} data-testid={`blog-article-${i}`}>
                    <h3 className="text-2xl font-light text-[#1a1a1a] tracking-tight mb-4" style={{ fontFamily: "Outfit, sans-serif" }}>
                      {article.title}
                    </h3>
                    {article.paragraphs.map((p, j) => (
                      <p key={j} className="text-[#555555] leading-relaxed text-base mb-4">{p}</p>
                    ))}
                    {article.list && (
                      <ul className="list-disc pl-6 space-y-2 mb-4">
                        {article.list.map((item, k) => (
                          <li key={k} className="text-[#555555] text-base leading-relaxed">{item}</li>
                        ))}
                      </ul>
                    )}
                    {i < BLOG_ARTICLES.length - 1 && <div className="w-16 h-px bg-[#E4DCCC] mt-12" />}
                  </article>
                ))}
              </div>
            </div>
          </ScrollReveal>
        </div>
      </section>

      <Footer />
    </div>
  );
}
